import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import './NotesWindow.scss'
import { Close } from '@mui/icons-material';
import Button from '../../../../components/library/buttons/Button';
import DefaultModal from '../../../../components/library/modal/DefaultModal';
import HrbTranslate from '../../../../components/language/HrbTranslate';
import WorkflowStatusIcon from '../../../../components/library/workflow-tasks/WorkflowStatusIcon'
import lang from '../../../../components/language/services/Lang'
import T from 'i18n-react';
import TaskErrorText from '../../../../components/library/workflow-tasks/TaskErrorText'

const AddNoteModal = (props) => {
    const language = lang.getCurrentLanguage()
    const inputRef = useRef();
    const addError = props.error;
    const [MAX_TEXT_LENGTH] = useState(170)
    const [inProgress, setInProgress] = useState(false);
    const [textLength, setTextLength] = useState(0)
    const [noteText, setNoteText] = useState('')
    const [oldNoteText, setOldNoteText] = useState('')

    const placeholderText = lang.getCurrentValue('Notes.AddNoteModal.PlaceHolderText')

    const addNewNote = (ev) => {
        setInProgress(true)
        setOldNoteText(noteText)
        props.onAddNote(noteText);
        setNoteText('')
        setInProgress(false)        
        setTextLength(0)
    }

    const handleCancel = (ev) => {
        setInProgress(false);
        setNoteText('')
        setTextLength(0)
        props.onCancel(ev);
    }   

    const handleChange = (ev) => {
        setTextLength(ev.target.value.length)
        setNoteText(ev.target.value)
    }

    useEffect(() => {
        if (props.updateFailed) {
            setInProgress(false)
        }
    }, [props.updateFailed])

    useEffect(() => {
        if (addError === true)
            setNoteText(oldNoteText)
        else if (addError === false && oldNoteText === noteText) {
            setNoteText('')
        }
        inputRef.current.focus();
    })

    return (
        <DefaultModal isOpen={props.isOpen}>
            <div className='workflow-modal'>
                <div className='header'>
                    <div className='header-title'>
                        <WorkflowStatusIcon status={props.status} />
                        <h4><HrbTranslate text='Notes.AddNoteModal.Title' /></h4>
                    </div>
                    <Close className='close-btn' onClick={handleCancel}/>
                </div>
                <div className='content'>
                    <textarea id='add-note-textarea' autoFocus style={{ resize: 'none', border: 'none', outline: 'none' }} name='body' rows='8' cols='70' maxLength={MAX_TEXT_LENGTH} placeholder={placeholderText}
                        onChange={handleChange}
                        value={noteText}
                        ref={inputRef} />
                    <div className='footer-section'>
                        <div className='button-holder'>
                            <Button
                                elementId='ticket-cancel-btn'
                                labelKey='Notes.AddNoteModal.AddButton'
                                buttonStyles='secondary'
                                onClick={addNewNote}
                                loading={inProgress}
                                disabled={noteText.length === 0}
                            />
                            <Button
                                elementId='ticket-cancel-btn'
                                labelKey='App.Cancel'
                                buttonStyles='tertiary'
                                onClick={handleCancel} />                            
                        </div>
                        <p >{textLength}/{MAX_TEXT_LENGTH}</p>                       
                    </div>
                    {addError && <TaskErrorText errorKey="Notes.ErrorFailedAddNote" />}
                </div> 
            </div>
        </DefaultModal>
    );
}

AddNoteModal.whyDidYouRender = false;

AddNoteModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCancel: PropTypes.func
}

export default AddNoteModal